import React from 'react'
import { useFormikContext } from 'formik'
import { debounce } from 'throttle-debounce'
import { rationalNumbers } from 'Core/masks'

import { TextInputNew, Wrapper } from 'SRC/ui/FormElementsNew'

export const PriceFromTo = () => {
	const formik = useFormikContext()

	const priceFromError = formik.errors.priceFrom && formik.touched.priceFrom
	const priceToError = formik.errors.priceTo && formik.touched.priceTo

	const priceFromErrorMessage = formik.errors.priceFrom
	const priceToErrorMessage = formik.errors.priceTo

	const priceFromValue = formik.values.priceFrom
	const priceToValue = formik.values.priceTo

	return (
		<React.Fragment>
			<Wrapper isError={priceFromError}>
				<TextInputNew
					id='priceFrom'
					name='priceFrom'
					title='Cijena od'
					value={formik.values.priceFrom}
					mask={rationalNumbers}
					allowedCharacters={['rational']}
					measure='€'
					onChange={debounce(750, async textValue => {
						const priceToValue = Number(formik.values.priceTo)

						const newPriceFromValue = textValue !== '' && Number(textValue) > priceToValue && ![0, 1].includes(Number(priceToValue))
							? formik.values.priceFrom
							: textValue

						await formik.setFieldValue('priceFrom', newPriceFromValue)
	
						if (!formik.touched.priceFrom) formik.setFieldTouched('priceFrom', true)

						formik.setErrors({
							...formik.errors,
							priceFrom: formik.touched.priceFrom && [0, -1].includes(Number(textValue)) ? 'Cijena od je obavezno polje' : undefined
						})
					})}
				/>
			</Wrapper>

			<Wrapper isError={priceToError}>
				<TextInputNew
					id='priceTo'
					name='priceTo'
					title='Cijena do'
					value={formik.values.priceTo}
					mask={rationalNumbers}
					allowedCharacters={['rational']}
					measure='€'
					onChange={debounce(750, async textValue => {
						console.log('priceTo', textValue)
						const priceFromValue = Number(formik.values.priceFrom)

						const newPriceToValue = textValue !== '' && Number(textValue) < priceFromValue && ![0, 1].includes(Number(priceFromValue))
							? formik.values.priceTo
							: textValue

						await formik.setFieldValue('priceTo', newPriceToValue)
	
						if (!formik.touched.priceTo) formik.setFieldTouched('priceTo', true)

						formik.setErrors({
							...formik.errors,
							priceTo: formik.touched.priceTo && [0, -1].includes(Number(textValue)) ? 'Cijena do je obavezno polje' : undefined
						})
					})}
				/>
			</Wrapper>
		</React.Fragment>
	)
}

